module.exports = __webpack_public_path__ + "img/iba-logo.299a76e7.svg";